import script from "./sf-input-base.vue?vue&type=script&setup=true&lang=ts&generic=MV"
export * from "./sf-input-base.vue?vue&type=script&setup=true&lang=ts&generic=MV"

import "./sf-input-base.vue?vue&type=style&index=0&id=8cda1c25&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cda1c25"]])

export default __exports__